import React from "react";
import Header from "../components/Header";
import HeroSection from "../components/HeroSection";
import OurStorySection from "../components/OurStorySection";
import SpecialPackageSection from "../components/SpecialPackageSection";
import TodaysMenuSection from "../components/TodaysMenuSection";
import WhyUsSection from "../components/WhyUsSection";
import AboutSection from "../components/AboutSection";
import BlogSection from "../components/BlogSection";
import GallerySection from "../components/GallerySection";
import Footer from "../components/Footer";

const HomePage = () => {
  return (
    <div className="rest-page">
      <Header />
      <main>
        <HeroSection />
        <OurStorySection />
        <SpecialPackageSection />
        <TodaysMenuSection />
        <WhyUsSection />
        <AboutSection />
        <BlogSection />
        <GallerySection />
      </main>
      <Footer />
    </div>
  );
};

export default HomePage;
